import React, { useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import styles from "./Accordion.module.css";

export interface AccordionItem {
  heading: string;
  content: string;
}

interface AccordionProps {
  items: AccordionItem[];
  className?: string;
  defaultOpen?: number | null; // Index of the item that should be open by default, or null for all closed
}

export const Accordion: React.FC<AccordionProps> = ({
  items,
  className = "",
  defaultOpen = null,
}) => {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  const handleItemClick = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className={`${styles.accordion} ${className}`}>
      {items.map((item, index) => (
        <div
          key={index}
          className={`${styles.accordionItem} ${
            openIndex === index ? styles.open : ""
          }`}
        >
          <button
            className={styles.accordionHeader}
            onClick={() => handleItemClick(index)}
            aria-expanded={openIndex === index}
            aria-controls={`accordion-content-${index}`}
          >
            <span className={styles.accordionTitle}>{item.heading}</span>
            <ExpandMoreIcon
              className={`${styles.accordionIcon} ${
                openIndex === index ? styles.rotated : ""
              }`}
            />
          </button>
          <div
            id={`accordion-content-${index}`}
            className={styles.accordionContent}
            aria-hidden={openIndex !== index}
          >
            <div
              className={styles.accordionContentInner}
              dangerouslySetInnerHTML={{ __html: item.content }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};
